import { c as _c } from "react/compiler-runtime";
import { useEffect, useMemo, useState } from "react";
import { Time } from "@/helpers/time";
import { getApprovalCountdownDelayMs, getApprovalDropStatus, type ApprovalDropStatus, type ApprovalDropStatusDrop } from "@/helpers/waves/approve-wave.helpers";
const MAX_TIMEOUT_MS = 2_147_483_647;
export function useApprovalDropStatus(t0) {
  const $ = _c(13);
  const {
    drop,
    isClosed: t1,
    winningThreshold,
    winningThresholdMinDurationMs
  } = t0;
  const isClosed = t1 === undefined ? false : t1;
  const [, setClockTick] = useState(0);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = Time.currentMillis();
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const nowMs = t2;
  let t3;
  if ($[1] !== drop || $[2] !== isClosed || $[3] !== winningThreshold || $[4] !== winningThresholdMinDurationMs) {
    t3 = getApprovalDropStatus({
      drop,
      isClosed,
      nowMs,
      winningThreshold,
      winningThresholdMinDurationMs
    });
    $[1] = drop;
    $[2] = isClosed;
    $[3] = winningThreshold;
    $[4] = winningThresholdMinDurationMs;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const status = t3;
  let t4;
  if ($[6] !== setClockTick || $[7] !== status.countdownMs || $[8] !== status.kind) {
    t4 = () => {
      if (status.kind !== "approving" || status.countdownMs === null) {
        return;
      }
      const delayMs = getApprovalCountdownDelayMs(status.countdownMs);
      if (delayMs === null) {
        return;
      }
      const timeoutId = globalThis.setTimeout(() => {
        setClockTick(_temp);
      }, Math.min(delayMs, MAX_TIMEOUT_MS));
      return () => {
        globalThis.clearTimeout(timeoutId);
      };
    };
    $[6] = setClockTick;
    $[7] = status.countdownMs;
    $[8] = status.kind;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== status.countdownMs || $[11] !== status.kind) {
    t5 = [status.countdownMs, status.kind];
    $[10] = status.countdownMs;
    $[11] = status.kind;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  useEffect(t4, t5);
  return status;
}
function _temp(tick) {
  return tick + 1;
}